import config from 'config'

export const getCertificationLink = certificateNumber =>
  certificateNumber && config.env.GRAPHQL_API_URL.concat('/certificate/').concat(certificateNumber)
